import useModalManagerStore from '../components/ModalManager/useModalManagerStore';

const useModalManager = useModalManagerStore;

export default useModalManager;
